export default {
  position: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Position",
      description: {
        xAxisReferenceLine: "Arrange relative to chart data points",
        legend: "Select the location for the legend",
        categoryAxis: "Select left or right",
        valueAxis: "Select left or right",
        y1AxisReferenceLine: "Arrange relative to chart data points",
        referenceLine: "Arrange relative to chart data points"
      }
    },
    value: "Top"
  },
  preset: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Preset",
      description: null
    },
    value: 'Custom'
  },
  tileShape: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Tile Shape",
      description: null
    },
    value: null
  },
  linecapType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Linecap Type",
      description: null
    },
    value: null
  },
  countType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Count Type",
      description: null
    },
    value: null
  },
  shadowPositionPreset: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: " Position Preset",
      description: null
    },
    value: null
  },
  mapTheme: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Theme",
      description: null
    },
    value: 'grayscale'
  },
  dataBarScalingType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Theme",
      description: null
    },
    value: 'grayscale'
  },
  markerStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showMarker',
      displayName: "Style",
      description: null
    },
    value: 'triangle'
  },
  distanceLabel: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showMarker',
      displayName: "Distance Label",
      description: null
    },
    value: 'triangle'
  },
  selectedNumericAnalysis: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Numeric Analysis",
      description: null
    },
    value: null
  },
  direction: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Style",
      description: null
    },
    value: 'Negative'
  },
  outline: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Outline",
      description: null
    },
    value: 'Frame'
  },
  projectionEnum: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Projection",
      description: null
    },
    value: 'Frame'
  },
  layerPosition: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Layers position",
      description: null
    },
    value: 'left'
  },
  infographicsPosition: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Infographics position",
      description: null
    },
    value: 'right'
  },
  country: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Country",
      description: null
    },
    value: 'world'
  },
  dataLabelDisplayUnits: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Label Display Units",
      description: null
    },
    value: 'Frame'
  },
  markerShape: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showMarker',
      displayName: "Marker shape",
      description: null
    },
    value: 'triangle'
  },
  connectorType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Marker shape",
      description: null
    },
    value: 'triangle'
  },
  aiMode: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "AI Mode",
      description: null
    },
    value: 'relative'
  },
  strokeLineJoin: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Join type",
      description: null
    },
    value: 'bevel'
  },
  rowSubtotalsPosition: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Alignment",
      description: null
    },
    value: 'Bottom'
  },
  labelDensity: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Label density",
      description: null
    },
    value: null
  },
  density: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Density",
      description: null
    },
    value: "sparse"
  },
  labelPosition: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Position",
      description: null
    },
    value: "OutsideEnd"
  },
  labelStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Label style",
      description: null
    },
    value: "Data"
  },
  page: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Page",
      description: null
    },
    value: "Auto"
  },
  labelOrientation: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Orientation",
      description: null
    },
    value: "vertical"
  },
  orientation: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Orientation",
      description: null
    },
    value: "vertical"
  },
  secLabelDisplayUnits: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Display units",
      description: "Select the units (millions, billions, etc.)"
    },
    value: "categorical"
  },
  mode: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Mode",
      description: null
    },
    value: "Basic"
  },

  axisScale: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Scale type",
      description: null
    },
    value: true
  },

  gridlineStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'gridlineShow',
      displayName: "Display units",
      description: null
    },
    value: "categorical"
  },
  lineStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'gridlineShow',
      displayName: "Line style",
      description: null
    },
    value: "dashed"
  },
  axisType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Type",
      description: null
    },
    value: "categorical"
  },
  axisStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showAxisTitle',
      displayName: "Style",
      description: null
    },
    value: "showTitleOnly"
  },
  secTitleStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showAxisTitle',
      displayName: "Style",
      description: null
    },
    value: "showTitleOnly"
  },
  style: {
    properties: {
      component: 'Select',
      type: "enumeration",
      visible: 'showAxisTitle',
      displayName: "Style",
      description: null
    },
    value: "showTitleOnly"
  },
  labelDisplayUnits: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Display units",
      description: "Select the units (millions, billions, etc.)"
    },
    value: "showTitleOnly"
  },
  imageScalingType: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Scaling Type",
      description: null
    },
    value: "Normal"
  },
  indicatorDisplayUnits: {
    properties: {
      component: 'Select',
      type: "formatting",
      displayName: "Display units",
      description: "Select the units (millions, billions, etc.)"
    },
    value: "Auto"
  },
  legendMarkerRendering: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Position",
      description: "Marker Rendering"
    },
    value: "markerOnly"
  },
  secPosition: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Position",
      description: "Select left or right"
    },
    value: "Left"
  },
  secAxisScale: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Scale type",
      description: null
    },
    value: "Log"
  },
  secScaleType: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Scale type",
      description: null
    },
    value: "Log"
  },
  type: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Visual Tooltip",
      description: null
    },
    value: "Default"
  },
  secAxisStyle: {
    properties: {
      component: 'Select',
      type: "enumeration",
      displayName: "Style",
      description: null
    },
    value: "Log"
  },
}